import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import { useTranslation } from '../i18n/TranslationContext';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { consumePendingConversion } from '../tracking/tracking';

const PaymentSuccess: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const payerId = searchParams.get('PayerID');

  useEffect(() => {
    // Log payment details for debugging
    console.log('Payment success', { token, payerId });
    // Traccia la conversione salvata prima del redirect al pagamento
    consumePendingConversion(token ?? undefined);
  }, [token, payerId]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: 80,
                color: 'success.main',
              }}
            />
          </Box>

          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            {t('esito.ok_titolo', 'Pagamento Completato!')}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {t('esito.ok_testo', 'La tua registrazione è stata confermata con successo. Riceverai una email di conferma a breve con tutti i dettagli.')}
          </Typography>

          {token && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 3 }}>
              {t('esito.transazione', 'ID Transazione')}: {token}
            </Typography>
          )}

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/')}
            sx={{ mt: 2 }}
          >
            {t('esito.home', 'Torna alla Home')}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentSuccess;
